export default __webpack_public_path__ + "static/media/harvLogo.dbe7c8c9.png";